import { setCookie, getCookie } from '../helpers/cookie';

const cookieName = 'ico-newsletter-interacted';

if (getCookie(cookieName) === 'true') {
    document.querySelector('.footer-newsletter-button').classList.add('footer-newsletter-button--hide');
}

document.querySelector('.btn-newsletter').addEventListener('click', () => {
    document.querySelector('.newsletter-modal').classList.add('newsletter-modal--active');
});

document.querySelector('.btn-mobile-newsletter').addEventListener('click', () => {
    document.querySelector('.newsletter-modal').classList.add('newsletter-modal--active');
});

document.querySelector('.footer-newsletter-button').addEventListener('click', (e) => {

    if (e.target.classList.contains('footer-newsletter-button__close')) {
        return
    }

    document.querySelector('.newsletter-modal').classList.add('newsletter-modal--active');
});

document.querySelector('.newsletter-modal__close').addEventListener('click', () => {
    document.querySelector('.newsletter-modal').classList.remove('newsletter-modal--active');
    closeButton();
});

document.querySelector('.newsletter-modal').addEventListener('click', (e) => {
    if (e.target.classList.contains('newsletter-modal')) {
        document.querySelector('.newsletter-modal').classList.remove('newsletter-modal--active');
        closeButton();
    }
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        document.querySelector('.newsletter-modal').classList.remove('newsletter-modal--active');
        closeButton();
    }
});

document.querySelector('.footer-newsletter-button__close').addEventListener('click', () => {
    closeButton();
})

function closeButton() {
    document.querySelector('.footer-newsletter-button').classList.add('footer-newsletter-button--hide');
    setCookie(cookieName, true, 365);
}